import React, { useState } from "react";

const ImageUpload = ({ onFileSelect }) => {
  const [preview, setPreview] = useState(null);

  // 🔷 IMAGE COMPRESSION (for better OCR)
  const compressImage = (file) => {
    return new Promise((resolve) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const MAX_WIDTH = 1200;

        let width = img.width;
        let height = img.height;

        if (width > MAX_WIDTH) {
          height = height * (MAX_WIDTH / width);
          width = MAX_WIDTH;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            const compressedFile = new File([blob], file.name, {
              type: "image/jpeg",
            });
            resolve(compressedFile);
          },
          "image/jpeg",
          0.7
        );
      };

      reader.readAsDataURL(file);
    });
  };

  // 🔷 HANDLE FILE SELECT
  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const compressed = await compressImage(file);

    setPreview(URL.createObjectURL(compressed)); // preview
    onFileSelect(compressed);
  };

  return (
    <div className="p-4 border rounded-lg space-y-3">

      {/* 🔷 ACTION BUTTONS */}
      <div className="flex flex-col gap-2">

        {/* Camera */}
        <label className="cursor-pointer bg-blue-50 border border-blue-200 rounded p-2 text-center text-sm">
          📷 Take Photo
          <input
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleChange}
            className="hidden"
          />
        </label>

        {/* Gallery */}
        <label className="cursor-pointer bg-gray-50 border rounded p-2 text-center text-sm">
          🖼 Choose from Gallery
          <input
            type="file"
            accept="image/*"
            onChange={handleChange}
            className="hidden"
          />
        </label>

      </div>

      {/* 🔷 IMAGE PREVIEW */}
      {preview && (
        <div className="mt-3">
          <p className="text-sm text-slate-500 mb-1">Preview:</p>
          <img
            src={preview}
            alt="preview"
            className="w-full max-h-60 object-contain border rounded"
          />
        </div>
      )}

    </div>
  );
};

export default ImageUpload;